
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M137.187 163.489l-19.25 19.25c-12.354 12.344-32.334 12.344-44.688 0-5.968-5.969-9.25-13.906-9.25-22.344 0-8.437 3.282-16.364 9.25-22.333l25.948-25.948c12.563-12.563 32.615-12.063 44.677 0 2.417 2.417 4.323 5.187 5.813 8.146l-8.5 8.49c-.958-3.272-2.667-6.344-5.136-8.813-7.729-7.73-20.968-8.052-29.01-.01l-.01.01-25.959 25.948c-8 8-8 21.02 0 29.02 8.094 8.084 21.115 7.928 29.032 0l12.927-12.937c5.302 1.52 9.552 1.792 14.156 1.52zm.864-90.23L118.99 92.334c4.51-.271 8.823 0 14.146 1.51l12.76-12.75c7.99-8.01 21.021-8 29.02 0 8.084 8.094 7.918 21.115 0 29.02l-25.78 25.782c-7.677 7.667-20.73 8.271-29.01-.01-2.522-2.532-4.188-5.563-5.105-8.76l-.448.353-8.083 8.084c1.49 2.969 3.385 5.729 5.802 8.146 11.969 11.979 32.02 12.666 44.677 0l25.77-25.76c12.345-12.355 12.355-32.334 0-44.678-12.364-12.375-32.364-12.333-44.687-.01zm0 0","fill":"#FFF","stroke-miterlimit":"10","font-family":"none","font-weight":"none","font-size":"none","text-anchor":"none"}})])
          )
        }
      }
    